var map = {
	"./agility.png": 6789,
	"./cooking.png": 9725,
	"./crafting.png": 7049,
	"./farming.png": 3637,
	"./firemaking.png": 2441,
	"./fishing.png": 9259,
	"./fletching.png": 1103,
	"./herblore.png": 5202,
	"./hunter.png": 8794,
	"./mining.png": 8270,
	"./runecrafting.png": 4623,
	"./slayer.png": 6794,
	"./smithing.png": 1640,
	"./stats.png": 8824,
	"./thieving.png": 5236,
	"./woodcutting.png": 5285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;